import { render, staticRenderFns } from "./IndividualMail.vue?vue&type=template&id=22ae5cca&"
import script from "./IndividualMail.vue?vue&type=script&lang=js&"
export * from "./IndividualMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports